import { useFormattedMessage } from "hooks";
import React from "react";
import WarningCirlce from "assets/images/svg/warning_circle.svg";

const messages = {
    records_out_of: "records_out_of",
    load_more: "load_more",
    more: "more",
    unable_to_load_list: "unable_to_load_list",
    try_again: "try_again",
};

export function RecordsLabel({ fetched = 0, totalRecords = 0, className = "" }) {
    const { formatMessage } = useFormattedMessage();

    //Show empty when no data available yet or all entried are fetched.
    if (totalRecords === 0 || fetched === 0) {
        return null;
    }
    return (
        <span className={`text-14 light-grey-color ${className}`}>
            {fetched + " " + formatMessage(messages.records_out_of) + " " + totalRecords}
        </span>
    );
}

export default function LoadMoreFooter({ fetched = 0, totalRecords = 0, loadingLimit = 0, onClick, error, loading }) {
    const { formatMessage } = useFormattedMessage();
    const remaininEntried = totalRecords - fetched;

    //show remaining if less then the loadingLimit
    const itemsToLoad = remaininEntried < loadingLimit ? remaininEntried : loadingLimit;

    //Show empty when no data available yet or all entried are fetched.
    if (loading || totalRecords === 0 || fetched === 0 || remaininEntried === 0) {
        return null;
    }
    return (
        <div className="d-flex align-center justify-end">
            {error ? (
                <div className="d-flex row align-center">
                    <WarningCirlce style={{ width: 32, height: 32 }} />
                    <span className="text-16 light-grey-color danger-red-color">
                        {formatMessage(messages.unable_to_load_list)}
                    </span>
                </div>
            ) : (
                <span className="text-16 light-grey-color">
                    {fetched + " " + formatMessage(messages.records_out_of) + " " + totalRecords}
                </span>
            )}

            <button
                className="ml-4 b-radius-2 px-4 py-2 bg-dark mw-fit secondary"
                onClick={() => onClick(!!error)} //this event will work for both try again and load more
            >
                <span className="text-14 mx-2">
                    {error
                        ? formatMessage(messages.try_again)
                        : formatMessage(messages.load_more) + " " + itemsToLoad + " " + formatMessage(messages.more)}
                </span>
            </button>
        </div>
    );
}
